import i18n, { type Resource } from "i18next";
import HttpBackend from "i18next-http-backend";
import YAML from "js-yaml";
import { initReactI18next } from "react-i18next";
import translationsConfig from "../../translation.config.json";

// VITE_COMMIT_HASH is defined at build time by build-config. When it is set,
// use a per-deploy filename so CloudFront never serves a stale translation file.
const commitHash = import.meta.env.VITE_COMMIT_HASH as string | undefined;
const i18nLoadPath = commitHash
  ? (import.meta.env.VITE_I18N_PATH as string).replace(
      "translation.yml",
      `translation.${commitHash}.yml`
    )
  : (import.meta.env.VITE_I18N_PATH as string);

i18n
  .use(HttpBackend) // Load translations using http (from public folder)
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    lng: "en",
    fallbackLng: "en",
    // debug: true,
    load: "currentOnly",
    supportedLngs: ["en", ...translationsConfig.locales],
    backend: {
      loadPath: i18nLoadPath,
      parse: (data: string) => YAML.load(data) as Resource,
    },
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
  })
  .catch((err) => {
    console.error("i18n init error", err);
  });

export default i18n;
